const PAYMENT_CODES: Record<string, string> = {
  Contado: 'C',
  Mensual: 'M',
  Semestral: 'S',
  Trimestral: 'T',
  Todas: 'C,S,T,M',
};

const PLAN_CODES: Record<string, string> = {
  Amplia: '1',
  Plus: '3',
  Limitada: '2',
  'Responsabilidad Civil': '4',
  Todas: '1,2,3,4',
};

export const mapFormaPago = (formaPago: string): string => PAYMENT_CODES[formaPago] || 'C';

export const mapPaquete = (planType: string): string => PLAN_CODES[planType] || '1';
